import { IVersionedChoice, PropertySheet, PropertySheetCategory, TypedCardElementPeer } from "adaptivecards-designer";
import {  getPropertyEditorInstance, PickerBase, PropertyKeys } from "./PickerBase";
import {  removeOtherPropertyConfigurations } from "../Utils/CustomElementUtils";

export class PriorityPicker extends PickerBase{
    static readonly JsonTypeName = "Priority";
    static readonly ElementId = "Ticket.Priority";
    static readonly defaultLabel = "Priority";
    static pickerChoices: any[];

    protected internalRender(): HTMLElement | undefined {
        this.id = PriorityPicker.ElementId;
        if((this?.displayLabel ?? "").length == 0)
            this.displayLabel = PriorityPicker.defaultLabel;

        if(PriorityPicker.pickerChoices){
            this.displayChoices = PriorityPicker.pickerChoices;
        }

        return super.internalRender();
    }
    
    getJsonTypeName(): string {
        return PriorityPicker.JsonTypeName;
    }
}

export class PriorityPickerPeer extends TypedCardElementPeer<PriorityPicker> {
    static displayLabelProperty = getPropertyEditorInstance(PriorityPicker.ElementId, PropertyKeys.displayLabel);
    static requireFieldProperty = getPropertyEditorInstance(PriorityPicker.ElementId, PropertyKeys.requireField);
    static dataSourceProperty = getPropertyEditorInstance(PriorityPicker.ElementId, PropertyKeys.dataSource, []);

    static updateChoices(choices: IVersionedChoice[]) {
        this.dataSourceProperty = getPropertyEditorInstance(PriorityPicker.ElementId, PropertyKeys.dataSource, choices);
    }

    populatePropertySheet(propertySheet: PropertySheet, defaultCategory: string = PropertySheetCategory.DefaultCategory) {
        
        super.populatePropertySheet(propertySheet, defaultCategory);
        removeOtherPropertyConfigurations(propertySheet);
        
        propertySheet.add(
            defaultCategory,
            PriorityPickerPeer.idProperty,
            PriorityPickerPeer.displayLabelProperty,
            PriorityPickerPeer.requireFieldProperty,
            PriorityPickerPeer.dataSourceProperty);
    
    }
}
